import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=39e1c086&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=39e1c086&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e1c086",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39e1c086')) {
      api.createRecord('39e1c086', component.options)
    } else {
      api.reload('39e1c086', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=39e1c086&scoped=true&", function () {
      api.rerender('39e1c086', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2n2LicZJZvGdt/JS/comp/DocBox.vue"
export default component.exports